import React from 'react'
import {
  Control,
  Controller,
  FieldErrors,
  FieldValues,
  UseFormRegister,
  UseFormReturn,
} from 'react-hook-form'

import { AppCheckBox } from 'components/Common/AppFormFields/AppCheckBox/AppCheckBox.component'
import { AppTextField } from 'components/Common/AppFormFields/AppTextField/AppTextField.component'
import { AppFacebookIcon } from 'components/Common/AppSvgIcons/AppFacebookIcon'
import { AppInstagramIcon } from 'components/Common/AppSvgIcons/AppInstagramIcon'
import { AppLinkedInIcon } from 'components/Common/AppSvgIcons/AppLinkedinIcon'
import { AppTikTokIcon } from 'components/Common/AppSvgIcons/AppTikTokIcon'
import { AppTwitterIcon } from 'components/Common/AppSvgIcons/AppTwitterIcon'
import { AppYouTubeIcon } from 'components/Common/AppSvgIcons/AppYouTubeIcon'

interface IAppEditBusinessSocialMediaFields {
  register: UseFormRegister<FieldValues>
  control: Control<FieldValues>
  errors: FieldErrors<FieldValues>
  setValue: UseFormReturn['setValue']
  watch: (name: string) => FieldValues[keyof FieldValues]
  clearErrors: (name?: keyof FieldValues) => void
}
export const AppEditBusinessSocialMediaFields: React.FC<IAppEditBusinessSocialMediaFields> = ({
  errors,
  watch,
  control,
  setValue,
  clearErrors,
}) => {
  const hasFacebook = watch('hasFacebook')
  const hasInstagram = watch('hasInstagram')
  const hasLinkedin = watch('hasLinkedin')
  const hasTikTok = watch('hasTikTok')
  const hasTwitter = watch('hasTwitter')
  const hasYoutube = watch('hasYoutube')

  return (
    <>
      <div>Business Social Media</div>
      <div className="w-full my-2">
        <Controller
          name={'facebook'}
          control={control}
          render={({ field }) => (
            <AppTextField
              size="md"
              {...field}
              LabelIcon={AppFacebookIcon}
              label={`${hasFacebook === false ? '' : ' *'}`}
              placeholder={`handle`}
              prefix="www.facebook.com/"
              error={(errors.facebook?.message as string) || ''}
              disabled={hasFacebook === false}
            />
          )}
        />

        <div className="pl-1 my-2">
          <Controller
            name="hasFacebook"
            control={control}
            defaultValue={true}
            render={({ field }) => (
              <AppCheckBox
                id="hasFacebook"
                label={'I don’t have one'}
                value={field.value === false}
                onChange={(e) => {
                  const isChecked = e.target.checked
                  field.onChange(!isChecked)
                  setValue('facebook', '')
                  clearErrors('facebook')
                }}
              />
            )}
          />
        </div>
        <div className="w-full">
          <Controller
            name="instagram"
            control={control}
            render={({ field }) => (
              <AppTextField
                size="md"
                type="text"
                LabelIcon={AppInstagramIcon}
                label={`${hasInstagram === false ? '' : ' *'}`}
                prefix="www.instagram.com/"
                placeholder="handle"
                error={errors.instagram?.message as string}
                {...field}
                disabled={hasInstagram === false}
              />
            )}
          />
          <div className="pl-1 my-2">
            <Controller
              name="hasInstagram"
              control={control}
              render={({ field }) => (
                <AppCheckBox
                  id="hasInstagram"
                  label={'I don’t have one'}
                  value={field.value === false}
                  onChange={(e) => {
                    const isChecked = e.target.checked
                    const newValue = !isChecked
                    field.onChange(newValue)
                    setValue('instagram', '')
                    clearErrors('instagram')
                  }}
                />
              )}
            />
          </div>
        </div>
        <div className="w-full ">
          <Controller
            name="linkedin"
            control={control}
            render={({ field }) => (
              <AppTextField
                size="md"
                type="text"
                placeholder="handle"
                prefix="www.linkedin.com/in/@"
                LabelIcon={AppLinkedInIcon}
                label={`${hasLinkedin === false ? '' : ' *'}`}
                error={errors.linkedin?.message as string}
                {...field}
                disabled={hasLinkedin === false}
              />
            )}
          />
          <div className="pl-1 my-2">
            <Controller
              name="hasLinkedin"
              control={control}
              defaultValue={true}
              render={({ field }) => (
                <AppCheckBox
                  id="hasLinkedin"
                  label={"I don't have one"}
                  value={field.value === false}
                  onChange={(e) => {
                    const isChecked = e.target.checked
                    const newValue = !isChecked
                    field.onChange(newValue)
                    setValue('linkedin', '')
                    clearErrors('linkedin')
                  }}
                />
              )}
            />
          </div>
        </div>
      </div>
      <div className="w-full ">
        <Controller
          name={'tiktok'}
          control={control}
          render={({ field }) => (
            <AppTextField
              size="md"
              {...field}
              LabelIcon={AppTikTokIcon}
              label={`${hasTikTok === false ? '' : ' *'}`}
              placeholder={`@handle`}
              prefix="www.tiktok.com/"
              error={(errors.tiktok?.message as string) || ''}
              disabled={hasTikTok === false}
            />
          )}
        />

        <div className="pl-1 my-2">
          <Controller
            name="hasTikTok"
            control={control}
            defaultValue={true}
            render={({ field }) => (
              <AppCheckBox
                id="hasTikTok"
                label={'I don’t have one'}
                value={field.value === false}
                onChange={(e) => {
                  const isChecked = e.target.checked
                  const newValue = !isChecked
                  field.onChange(newValue)
                  setValue('tiktok', '')
                  clearErrors('tiktok')
                }}
              />
            )}
          />
        </div>
        <div className="w-full ">
          <Controller
            name="twitter"
            control={control}
            render={({ field }) => (
              <AppTextField
                size="md"
                type="text"
                LabelIcon={AppTwitterIcon}
                label={`${hasTwitter === false ? '' : ' *'}`}
                placeholder="handle"
                prefix="www.x.com/"
                error={errors.twitter?.message as string}
                {...field}
                disabled={hasTwitter === false}
              />
            )}
          />
          <div className="pl-1 my-2">
            <Controller
              name="hasTwitter"
              control={control}
              defaultValue={true}
              render={({ field }) => (
                <AppCheckBox
                  id="hasTwitter"
                  label={'I don’t have one'}
                  value={field.value === false}
                  onChange={(e) => {
                    const isChecked = e.target.checked
                    const newValue = !isChecked
                    field.onChange(newValue)
                    setValue('twitter', '')
                    clearErrors('twitter')
                  }}
                />
              )}
            />
          </div>
        </div>
        <div className="w-full ">
          <Controller
            name="youtube"
            control={control}
            render={({ field }) => (
              <AppTextField
                size="md"
                type="text"
                placeholder="@handle"
                prefix="www.youtube.com/"
                LabelIcon={AppYouTubeIcon}
                label={`${hasYoutube === false ? '' : ' *'}`}
                error={errors.youtube?.message as string}
                {...field}
                disabled={hasYoutube === false}
              />
            )}
          />
          <div className="pl-1 my-2">
            <Controller
              name="hasYoutube"
              control={control}
              defaultValue={true}
              render={({ field }) => (
                <AppCheckBox
                  id="hasYoutube"
                  label={'I don’t have one'}
                  value={field.value === false}
                  onChange={(e) => {
                    const isChecked = e.target.checked
                    const newValue = !isChecked
                    field.onChange(newValue)
                    setValue('youtube', '')
                    clearErrors('youtube')
                  }}
                />
              )}
            />
          </div>
        </div>
      </div>
    </>
  )
}
